import { IDoctor } from './doctor.view-model';
import { IPatient } from './patient.view-model';
import { IReceptionist } from './receptionist.view-model';
import { TGuid } from '@core/helpers';
import { EProfileTypeDTO, getProfileTypeLocalization } from './consts/profile-type';
import { ProfileHelper } from './helpers/profile.helper';
import { IProfile } from './profile.view-model';
import { INurse } from './nurse.view-model';

export interface IRequisitionParticipant {
  id: TGuid;
  fullName: string;
  phone?: string;
  photoUrl: string;
  profileType: EProfileTypeDTO;
  summaryInfo: string[];
  cpfNumber: string;
}

export class RequisitionParticipantViewModel {
  static create(profile: IDoctor | IPatient | IReceptionist | INurse | IProfile): IRequisitionParticipant {
    let summaryInfo = [];
    let cpfNumber: string;

    switch (profile.profileType) {
      case EProfileTypeDTO.Doctor: {
        summaryInfo = ProfileHelper.getDoctorSummaryInfo({
          specialization: profile.specialization,
        });
        break;
      }
      case EProfileTypeDTO.Patient: {
        summaryInfo = (profile as IPatient).summaryInfo;
        cpfNumber = profile.cpfNumber;
        break;
      }
      case EProfileTypeDTO.Receptionist: {
        summaryInfo = [getProfileTypeLocalization(EProfileTypeDTO.Receptionist)];
        break;
      }
      case EProfileTypeDTO.Nurse: {
        summaryInfo = [getProfileTypeLocalization(EProfileTypeDTO.Nurse)];
        break;
      }
    }

    return {
      id: profile.id,
      fullName: profile.fullName,
      phone: profile.phone,
      profileType: profile.profileType,
      summaryInfo,
      photoUrl: profile.photoUrl,
      cpfNumber,
    };
  }
}
